import React, { useRef, useState } from 'react'
import NewTopNavBar from './NewTopNavBar'
import { Button, Spinner } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import { FaCircle, FaMicrophone } from 'react-icons/fa'
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk"; // Import Speech SDK
const VideoTranscript = () => {
    const [selectedFile, setSelectedFile] = useState(null)
    const [apiResponse, setApiResponse] = useState()
    const [isDesable, setIsDesable] = useState(false)
    const [isCreateArticle, setIsCreateingArticle] = useState(false)
    const [articleRes, setArticleRes] = useState()
    const [isRecording, setIsRecording] = useState(false);
    const [articleTitle, setArticleTitle] = useState('')
    const recognizerRef = useRef(null);
    const [transcription, setTranscription] = useState("");
    const [data, setData] = useState({
        scriptId: "",
        scriptName: "",
        message: "",
    });
    const startTranscription = async () => {
        setIsRecording(true);

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
            "4dF8iLZOx3vaaFtd9EzT2xnRFgWz8ouaEhyAB108zDQjxdlOuTqbJQQJ99AKACYeBjFXJ3w3AAAYACOGFfCZ",
            "eastus"
        );
        speechConfig.speechRecognitionLanguage = "en-US";

        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new SpeechSDK.SpeechRecognizer(
            speechConfig,
            audioConfig
        );

        // Save the recognizer instance
        recognizerRef.current = recognizer;

        recognizer.recognizing = (s, e) => {
            console.log(`Recognizing: ${e.result.text}`);
        };

        recognizer.recognized = (s, e) => {
            if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                const recognizedText = e.result.text.trim(); // Get the newly recognized text
                setTranscription((prev) => `${prev} ${recognizedText}`); // Update transcription state

                setData((prevData) => ({
                    ...prevData,
                    message: prevData.message
                        ? `${prevData.message} ${recognizedText}`
                        : recognizedText,
                }));

                console.log(`Recognized: ${recognizedText}`);
            } else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
                console.log("No speech recognized.");
            }
        };

        recognizer.canceled = (s, e) => {
            console.error(`Canceled: ${e.errorDetails}`);
            recognizer.close();
            recognizerRef.current = null; // Clean up the recognizer reference
            setIsRecording(false);
        };

        recognizer.sessionStopped = (s, e) => {
            console.log("Session stopped.");
            recognizer.close();
            recognizerRef.current = null;
            setIsRecording(false);
        };

        recognizer.startContinuousRecognitionAsync();
    };
    const stopTranscription = () => {
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                console.log("Recognition stopped.");
                recognizerRef.current.close();
                recognizerRef.current = null;
            });
        }
        setIsRecording(false);
    };
    const config = {
        headers: {

            "Content-Type": "application/json",
        },
    };
    const handleFileChange = (e) => {
        console.log(e.target.files[0])
        setSelectedFile(e.target.files[0])
    }
    const handleSubmit = () => {
        if (!selectedFile) {
            toast.error("Please select file.");
            return
        }
        const maxSize = 25 * 1024 * 1024; // 25 MB in bytes
        if (selectedFile.size > maxSize) {
            toast.error("File size must not exceed 25 MB.");
            setSelectedFile(null); // Clear the selected file
            return;
        }

        setIsDesable(true)
        const formData = new FormData();
        formData.append("file", selectedFile);
        axios
            .post(`${window.location.origin}/video-transcript/transcribe`, formData)
            .then((res) => {
                console.log(res.data);
                setApiResponse(res.data.transcript)
                // setData(...data, { message: res.data.transcript })
                setData(prevData => ({
                    ...prevData,
                    message: res.data.transcript  // Updating scriptId
                }));
                setIsDesable(false)
                toast.success("Transcript generated successfully")
            }).catch((err) => {
                console.log(err)
                toast.error(err.response.data.error)
                setIsDesable(false)
            })
    }
    const handleChange = (e) => {
        console.log("handle change");
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleCreateArticle = () => {
        setIsCreateingArticle(true)
        const ticketStr = { ticketStr: data.message }
        console.log(apiResponse.length)
        axios.post(`${window.location.origin}/generate-article/generate-article`, ticketStr, config).then((res) => {
            console.log("line44=", res.data)
            setArticleRes(res.data.article)
            const parser = new DOMParser();

            // Parse the HTML string to create a document
            const doc = parser.parseFromString(res.data.article, 'text/html');
            const titleText = doc.title;
            setArticleTitle(titleText)
            // alert(titleText);
            toast.success("Article created successfully")

            setIsCreateingArticle(false)
        }).catch((err) => {
            setIsCreateingArticle(false)
            console.log(err)
        })
    }
    const goBackClick = () => {
        setArticleRes(null)
        setApiResponse(null)
        setData({
            scriptId: "",
            scriptName: "",
            message: "",
        })
    }
    const downloadFile = async () => {
        //
        const blob = new Blob([articleRes], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = articleTitle;
        a.click();
        URL.revokeObjectURL(url);
        // 

        toast.success(
            `Article is downloaded successfully`
        );
    };
    return (
        <div>
            <div>
                <NewTopNavBar />
            </div>
            {articleRes ? <div className=''> <div className="pt-5 px-4" dangerouslySetInnerHTML={{ __html: articleRes ? articleRes : "" }} />
                <div className='text-center'>
                    <Button onClick={goBackClick}>Go Back</Button>
                    <Button onClick={downloadFile}>Download</Button>
                </div>
            </div> :
                <div className='container pt-5'>

                    <div>
                        <div>
                            <h3 className='text-center pb-4'>Video Transcription </h3>

                            <div className='p-2' stytle={{ border: "1px solid gray" }}>This tool extracts text from an uploaded video, automatically generating a transcript. An AI Engine enhances it, transforming the text into a well-structured article format. The article can be downloaded as an HTML file . This ensures that users have a professional-quality document ready for use, whether for publication, sharing, or archiving.</div>
                        </div>
                        <div className='upload-users-section input-group align-items-center'>
                            <input className='form-control ' type="file" name="" id="csvFile" accept='.mp4' onChange={handleFileChange} />
                            <div>
                                <Button
                                    disabled={isDesable}
                                    onClick={handleSubmit}>{isDesable ? "Generating..." : "Generate"}</Button>

                            </div>
                        </div>
                        {isDesable ?
                            <div className='text-center pt-5'>
                                <Spinner />
                            </div>
                            :

                            <div>
                                {/* <textarea name="" id="" value={apiResponse}></textarea> */}
                                {/* <p className='pt-4'>{apiResponse ? apiResponse : ""}</p> */}
                                {/*  */}
                                {data.message.length > 0 ?
                                    <div className="form-group pt-4 " style={{ position: "relative" }}>
                                        <textarea
                                            className="form-control textarea"
                                            placeholder="You can paste the message or use the microphone to generate the message as you create a scenario in Oracle"
                                            name="message"
                                            value={data.message}
                                            onChange={handleChange}
                                            style={{
                                                minHeight: "280px",
                                                background: "gainsboro",
                                                position: "relative",
                                                paddingRight: "40px", // Leave space for the mic icon
                                                paddingTop: "20px",
                                                paddingLeft: "20px",
                                            }}
                                        />
                                        {/* Mic Icon */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                bottom: "10px",
                                                right: "15px",
                                                cursor: "pointer",
                                                display: "none"
                                            }}
                                            onClick={
                                                isRecording ? stopTranscription : startTranscription
                                            }
                                        >
                                            <FaMicrophone
                                                className='d-none'
                                                size={24}
                                                color={isRecording ? "red" : "black"} // Change mic color when active
                                                title={
                                                    isRecording ? "Stop Listening" : "Start Listening"
                                                }
                                            />
                                        </div>
                                        {/* Recording Indicator */}
                                        {isRecording && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "8px",
                                                    right: "15px",
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <FaCircle size={8} style={{ marginRight: "5px" }} />
                                                Recording...
                                            </div>
                                        )}
                                    </div>
                                    : ""}
                                {/*  */}
                                <div className='text-end'>
                                    {apiResponse ? <Button disabled={isCreateArticle} onClick={handleCreateArticle}>{isCreateArticle ? "Creating Article" : "Create Article"}</Button>

                                        : ""}
                                </div>
                                {isCreateArticle ?
                                    <div className='text-center pt-3'>
                                        <Spinner />
                                    </div>
                                    : ""}
                            </div>
                        }
                    </div>


                </div>
            }


        </div>
    )
}

export default VideoTranscript